/**
* ユーザー管理関連
*/

import axios from '@/plugins/axios';
import cf from '@/mixins/commonFunctions';
import login from './login';
import stripe from './stripe';

const actions = {
  setUserData({ commit }, data) {
    commit('setUserData', data);
  },


  /** DBからユーザー情報を取得しstate更新 */
  update({ commit, state }) {
    const ls = cf.getLocalStorage('sma_order');
    // localStorageが存在しない場合はスルー
    if (!ls) return;

    if (state.login.isLogin && ls.jwt) {
      axios({
        method: 'GET',
        url: '/v1/user/get/detail',
        params: {
          id: state.id,
        },
      })
        .then((response) => {
          const user = response.data.detail;
          commit('update', user);
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    }
  },
};

const mutations = {
  setUserData(state, data) {
    if (!data) return;
    Object.keys(state).forEach((key) => {
      if (data[key] !== undefined && key !== 'password') {
        state[key] = data[key];
      }
    });
    const userToSave = { ...state };
    delete userToSave.login;
    delete userToSave.stripe;
    
    cf.saveLocalStorage({ user: JSON.stringify(userToSave) }, 'sma_order');
  },

  update(state, user) {
    const userKeys = Object.keys(user);
    const stateKeys = Object.keys(state);
    // 取得したuserの値をまわして
    userKeys.some((key) => {
      // キーが存在するstateを更新
      if (stateKeys.includes(key)) {
        // console.log(key);
        state[key] = user[key];
      }
      return false;
    });
  },
};

const state = {
  id: '',
  name: '',
  email: '',
  role: '',
};


export default {
  namespaced: true,
  actions,
  mutations,
  state,
  modules: {
    login,
    stripe,
  },
};
